import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type ArchiveAccountLocationMutationVariables = GraphQLTypes.Exact<{
  locationId: GraphQLTypes.Scalars['String']['input'];
}>;

export type ArchiveAccountLocationMutationResult = { __typename?: 'Mutation' } & {
  archiveAccountLocation?: GraphQLTypes.Maybe<
    { __typename?: 'ArchiveAccountLocationPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'path'>>>;
    }
  >;
};

export const ArchiveAccountLocationDocument = gql`
  mutation archiveAccountLocation($locationId: String!) {
    archiveAccountLocation(locationId: $locationId) {
      errors {
        path
      }
    }
  }
`;
